export class ReferenceDataCategoriesConstants {
  public static readonly CLIENT_ENVIRONMENT_CATEGORY = 'ClientEnvironment';

  public static readonly LABEL = 'Label';

  public static readonly INPUT_LABEL = 'InputLabel';

  public static readonly CLIENT_SECTION_CUSTOMIZATION = 'ClientSectionCustomization';

  // Don't change the order of the elements in this array. The localize label pipe searches for values based on this order.
  public static readonly LABEL_CATEGORIES = [
    ReferenceDataCategoriesConstants.INPUT_LABEL,
    ReferenceDataCategoriesConstants.LABEL,
    'PolicyRule',
    'MarketingMessage',
    'ClientErrorMessage',
    ReferenceDataCategoriesConstants.CLIENT_SECTION_CUSTOMIZATION
  ];

  public static readonly INPUT_LABEL_CATEGORIES = [
    ReferenceDataCategoriesConstants.INPUT_LABEL,
    ReferenceDataCategoriesConstants.LABEL
  ];

  public static readonly OPTION_LIST_CATEGORY = 'OptionListValue';

  public static readonly OPTION_LIST_CATEGORIES = [
    ReferenceDataCategoriesConstants.OPTION_LIST_CATEGORY,
    'LoanGroupType',
    'TransactCode'
  ];

  public static readonly TOOLTIP = 'Tooltip';

  public static readonly ERROR_MESSAGE = 'ErrorMessage';

  public static readonly CONTEXTUAL_HELP = 'ContextualHelp';

  public static readonly CLIENT_ENVIRONMENT = 'ClientEnvironment';

  public static readonly NEW_FEATURES = 'NewFeatures';

  public static readonly UI_CUSTOMIZATION = 'UICustomization';

  public static readonly ALLOWED_BROWSERS = 'AllowedBrowsers';

  public static readonly PHONE_CONTEXT_BLACKLIST = 'PhoneContextBlacklist';

  public static readonly BLOCKED_MOBILE_USER_AGENT = 'BlockedMobileUserAgent';
}
